module.exports = __webpack_public_path__ + "static/media/alchemy.7aef2f8e.png";